module.exports = __webpack_public_path__ + "media/steps/loader_icon_1_old-9c6482c9.png";